import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María González', 'Carmen Flores', 'Lucía Martínez', 'Isabel Torres', 'Rosa Sánchez', 'Elena Ramírez', 'Sofía Morales', 'Andrea Castro', 'Gabriela Ortiz', 'Valentina Díaz', 'Daniela Vargas', 'Carolina Méndez', 'Fernanda Silva', 'Camila Herrera', 'Natalia Jiménez', 'Paula Gutiérrez', 'Alejandra Rojas', 'Mónica Pérez', 'Laura Reyes', 'Ana Rodríguez', 'Patricia Ruiz', 'Claudia López', 'Verónica Muñoz', 'Diana Romero', 'Sandra Navarro', 'Beatriz Guerrero', 'Cristina Medina', 'Silvia Cortés', 'Adriana Vega', 'Mariana Cruz', 'Rocío Delgado', 'Pilar Aguilar', 'Teresa Ramos', 'Gloria Mendoza', 'Raquel Fuentes', 'Yolanda Campos', 'Dolores Ríos', 'Amparo Salazar', 'Consuelo Domínguez', 'Inés Peña'];
const cities = ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'León', 'Cancún', 'Mérida', 'Querétaro', 'San Luis Potosí', 'Aguascalientes', 'Toluca', 'Chihuahua', 'Morelia', 'Hermosillo', 'Saltillo', 'Veracruz', 'Villahermosa', 'Oaxaca', 'Tuxtla Gutiérrez', 'Culiacán', 'Mazatlán', 'Playa del Carmen', 'Pachuca', 'Cuernavaca', 'Tampico', 'Durango', 'Celaya', 'Irapuato'];
export function RecentPurchaseToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const [recentIndices, setRecentIndices] = useState<number[]>([]);
  const getRandomIndex = (max: number, exclude: number[]) => {
    let index;
    do {
      index = Math.floor(Math.random() * max);
    } while (exclude.includes(index));
    return index;
  };
  const showNewPurchase = () => {
    const nameIndex = getRandomIndex(names.length, recentIndices);
    const cityIndex = Math.floor(Math.random() * cities.length);
    setCurrentPurchase({
      name: names[nameIndex],
      city: cities[cityIndex]
    });
    const newRecentIndices = [...recentIndices, nameIndex].slice(-10);
    setRecentIndices(newRecentIndices);
    setIsVisible(true);
    setTimeout(() => setIsVisible(false), 4000);
  };
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNewPurchase();
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      const randomDelay = Math.random() * 7000 + 8000; // 8-15 seconds
      const timer = setTimeout(() => {
        showNewPurchase();
      }, randomDelay);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  return <AnimatePresence data-id="element-151">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 max-w-sm w-full mx-4" data-id="element-152">
          <div className="bg-white rounded-lg shadow-2xl p-4 flex items-center gap-4 border border-border" data-id="element-153">
            <img src="https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=100&h=100&fit=crop" alt="Producto" className="w-12 h-12 rounded object-cover flex-shrink-0" data-id="element-154" />
            <div className="flex-1 min-w-0" data-id="element-155">
              <p className="text-sm font-semibold text-dark truncate" data-id="element-156">
                {currentPurchase.name} en {currentPurchase.city}
              </p>
              <p className="text-xs text-body" data-id="element-157">
                acaba de comprar{' '}
                <span className="font-semibold" data-id="element-158">Sistema Mamá IA</span> — $110
                MXN
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}